import {useEffect} from 'react';
import {Keyboard} from 'react-native';
import {useAppDispatch} from '../store/hooks';
import {setKeyboardHeight} from '../store/slices/ui';

export function useKeyboardDispatcher() {
  const dispatch = useAppDispatch();
  useEffect(() => {
    Keyboard.addListener('keyboardDidShow', e =>
      dispatch(
        setKeyboardHeight({keyboardHeight: e.endCoordinates.height}),
      ),
    );
    Keyboard.addListener('keyboardDidHide', () =>
      dispatch(setKeyboardHeight({keyboardHeight: 0})),
    );

    return () => {
      Keyboard.removeAllListeners('keyboardDidShow');
      Keyboard.removeAllListeners('keyboardDidHide');
    };
  }, []);
}
